<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">

        <h1 class="font-weight-bold text-primary mb-8 mt-4">الاهداف</h1>
        <p class="h5 line-height-xl text-dark-65">


          تنفيذا للأوامر السامية فقد سعى المركز السعودي لكفاءة الطاقة لتمكين الجهات الحكومية لكي ترفع كفاءة استهلاكها
          للطاقة في جميع منشآتها ومقارها ، وتزويد هذه الجهات بالوسائل المساعدة على ذلك من خلال عقد ورش عمل فنية مع
          المختصين في فرق كفاءة الطاقة بهذه الجهات، وتزويدهم بالنماذج والأدلة الإرشادية اللازمة، بالإضافة لتقديم الدعم
          اللازم لتنفيذ البرامج والأنشطة التوعوية بهدف رفع الوعي لدى منسوبيها بأهمية الترشيد ورفع كفاءة الطاقة، فضلاً عن
          تقديم برامج تدريبية لمنسوبي الجهات الحكومية بهدف رفع جداراتهم في مجالات كفاءة الطاقة.

        </p>

      </div>

      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>